import React, { useCallback } from 'react';
import { useTranslation } from '@hooks/useTranslation';
import { gregorian_fr, calendar_fr, forceUtcToParisTime } from '@utils/dateUtils';
import DateObject from "react-date-object";
import calendar_en from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

export const useDateTimeHelpers = () => {
    const { i18n } = useTranslation();
    const currentLanguage = i18n?.language || 'en';

    const gregorian = currentLanguage === 'fr' ? calendar_fr : calendar_en;

    const getDateLocale = useCallback(() => {
        return currentLanguage === 'fr' ? gregorian_fr : gregorian_en;
    }, [currentLanguage]);

    const getDateFormat = useCallback(() => {
        return currentLanguage === 'fr' ? 'dddd DD/MM/YYYY HH:mm' : 'dddd MM/DD/YYYY HH:mm';
    }, [currentLanguage]);

    const createDateObject = useCallback((dateValue) => {
        if (!dateValue) return null;

        return new DateObject({
            date: new Date(dateValue),
            calendar: gregorian,
            locale: getDateLocale()
        });
    }, [gregorian, getDateLocale]);

    const createDateObjectFromUtc = useCallback((utcDateString) => {
        if (!utcDateString) return null;

        // Convert UTC string to Paris time first
        const parisDate = forceUtcToParisTime(utcDateString);

        return new DateObject({
            date: parisDate,
            calendar: gregorian,
            locale: getDateLocale()
        });
    }, [gregorian, getDateLocale]);

    return {
        currentLanguage,
        gregorian,
        getDateLocale,
        getDateFormat,
        createDateObject,
        createDateObjectFromUtc
    };
};

export default useDateTimeHelpers;
